<template>
	<div>
		<action-sidebar
			title="Detalle"
			:value="value"
			@close-modal="closeModal"
		>
			<v-layout wrap mt-5 ml-5 mr-4>
				<v-flex xs3>
					<p class="font-weight-bold body-1">Nombre :</p>
				</v-flex>
				<v-flex xs9>
					<p class="body-1">{{dataResponse.name}}</p>
				</v-flex>
				<v-flex xs3>
					<p class="font-weight-bold body-1">Descripción:</p>
				</v-flex>
				<v-flex xs9>
					<p class="body-1">{{dataResponse.description}}</p>
				</v-flex>
				<v-flex xs3>
					<p class="font-weight-bold body-1">Módulos:</p>
				</v-flex>
					<v-flex xs9>
					<p class="body-1">
						<v-expansion-panel class="expansion-panel-template" v-if="dataResponse.template">
							<v-expansion-panel-content
								v-for="rol in dataResponse.template.roles"
								:key="rol.nameRole"
								:hide-actions="lengthArray(rol.resources)"
								class="transparent">
								<div slot="header">{{rol.nameRole}}</div>
								<v-expansion-panel
									v-for="resource in rol.resources"
									:key="resource.id"
									class="expansion-panel-template ml-4"
									>
									<v-expansion-panel-content 
										class="transparent"
										:hide-actions="lengthArray(resource.actions)">
										<div slot="header">{{resource.name}}</div>
										<v-expansion-panel
											v-for="action in resource.actions"
											:key="action.id"
											class="expansion-panel-template ml-4">
											<v-expansion-panel-content 
												class="transparent"
												hide-actions>
												<div slot="header">{{action.name}}</div>
											</v-expansion-panel-content>
										</v-expansion-panel>	
									</v-expansion-panel-content>	
								</v-expansion-panel>	
							</v-expansion-panel-content>
						</v-expansion-panel>	
					</p>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="loading"
					:on-run-service="loading"
					@cancel-button-clicked="closeModal"
					@accept-button-clicked="closeModal"
				/>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';

function closeModal() {
	this.loading = true;
	this.goTo('page-template', { params: { projectId: this.projectId } });
	this.loading = false;
}

async function created() {
	const query = {
		headers: {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		},
	};
	const result = await this.$http.get(`template/${this.id}`, query);
	this.dataResponse = result.data.data;
}

function lengthArray(array) {
	return !array.length > 0;
}

function data() {
	return {
		dataResponse: {},
		loading: false,
		value: true,
	};
}

export default {
	name: 'page-template-detail',
	data,
	components: {
		actionSidebar,
	},
	created,
	methods: {
		closeModal,
		lengthArray,
	},
	props: {
		id: {
			type: [Number, String],
		},
		projectId: {
			type: [Number, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/template/page-template-detail.vue